import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hour',
    standalone: false
})
export class HourPipe implements PipeTransform {
  transform(date: Date | string): string {
    if (!!date) {
      if (typeof date === 'string') {
        // Check if the string is in the HH:mm:ss format
        const timeFormatRegex = /^\d{2}:\d{2}:\d{2}$/;
        if (timeFormatRegex.test(date)) {
          const [hours, minutes] = date.split(':').map(time => time.padStart(2, '0'));
          return `${hours}:${minutes}`;
        }
        // Else check if the string is an ISO date string
        else if (!isNaN(Date.parse(date))) {
          if (date.includes('+')) {
            date = date.split('+')[0];
          }
          date = new Date(date);
        } else {
          // Handle other string formats if needed
          return null;
        }
      }

      // TypeScript now knows date is a Date object
      const dateObj = date as Date;
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');

      return `${hours}:${minutes}`;
    }

    return null;
  }
}
